module.exports = __webpack_public_path__ + "img/linkedin.3d5b6187.svg";